import clsx from "clsx";

type Props = {
  description: string;
  className?: string;
};

export default function BusinessTooltipContent({ description, className }: Props) {
  return (
    <div className={clsx("w-[27.4rem] bg-[#1E1E1E] border border-white/6 rounded-2xl", className)}>
      <div className="relative size-full py-3 px-4 rounded-2xl overflow-clip">
        <p className="relative z-1 text-13 font-medium text-white leading-[1.125rem]">
          {description}
        </p>
      </div>
    </div>
  );
}
